import React from "react";

const schedule = [
  {
    name: "Сүхбаатар",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Дорнод",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Хэнтий",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Дундговь",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Дорноговь",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Өмнөговь",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Говьсүмбэр",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Төв",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Орхон",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Булган",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Дархан-Уул",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Сэлэнгэ",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Хөвсгөл",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5Ah",
  },
  {
    name: "Архангай",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Өвөрхангай",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Баянхонгор",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Завхан",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Увс",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Говь-Алтай",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Баян-Өлгий",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Ховд",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
  {
    name: "Нийслэл",
    dateFrom: "2026.08.04",
    dateTo: "14:00",
    link: "https://forms.gle/T3u14ZESYU883Zv5A",
  },
];

export default function Schedule() {
  return (
    <div class="container">
      <div class="section-title mt-5" data-aos="fade-up">
        <h2>Хуваарь</h2>
        <p>ТӨСВИЙН ШИНЭЧЛЭЛ 2027 УУЛЗАЛТ</p>
      </div>
      <div className="att-table-container ">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>№</th>
              <th style={{ textAlign: "left" }}>Аймаг</th>
              <th style={{ textAlign: "left" }}>Уулзалт болох өдөр</th>
              <th style={{ textAlign: "left" }}>Эхлэх цаг</th>
              <th style={{ textAlign: "left" }}>Линк</th>
            </tr>
          </thead>
          <tbody>
            {schedule.map((el, i) => (
              <tr>
                <td>{i + 1}</td>
                <td>{el.name}</td>
                <td>{el.dateFrom}</td>
                <td>{el.dateTo}</td>
                <td>
                  <a
                    href={
                      el.link != ""
                        ? el.link
                        : "javascript:alert('Уулзалтын онлайн хурал эхлэх болоогүй');"
                    }
                    target={el.link != "" && "_blank"}
                  >
                    Оролцох
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
